<template>
  <div class="yhys-page">
    <div class="yhys-page__container">
      <h1 class="yhys-page__title">用户协议与隐私政策</h1>
      
      <div class="yhys-page__tabs">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          class="yhys-page__tab"
          :class="{ 'yhys-page__tab--active': activeTab === tab.id }"
          @click="activeTab = tab.id"
        >
          {{ tab.name }}
        </button>
      </div>

      <div class="yhys-page__content">
        <div v-if="activeTab === 'agreement'" class="yhys-page__section">
          <div class="yhys-page__article">
            <h2 class="yhys-page__article-title">用户协议</h2>
            
            <div class="yhys-page__content-body">
              <h3 class="yhys-page__heading">一、协议前言与适用说明</h3>
              <p class="yhys-page__paragraph">
                欢迎使用本yours网站（以下简称“本站”）所有服务！在注册账号、浏览页面、试听yours、开通会员、下载原创曲目前，请您认真阅读本《用户服务协议》。您的注册、登录、浏览、付费、下载等任何使用行为，均视为自愿同意并完全接受本协议全部条款。
              </p>
              <p class="yhys-page__paragraph">
                本站核心服务为：展示、播放、试听平台签约yours作品，为付费会员提供原创歌曲高清下载、专属试听权益等增值服务。本站所有上线音乐均为原创作品，全部经过版权审核，无盗版、无侵权搬运，平台严格保护yours版权。
              </p>
              <p class="yhys-page__paragraph">
                本协议适用于所有注册用户、普通浏览用户、付费会员用户、内容评论用户等全部使用本站服务的主体。若您不认可本协议任意条款，请立即停止使用本站所有服务。
              </p>

              <h3 class="yhys-page__heading">二、账号注册与使用规则</h3>
              <p class="yhys-page__paragraph">
                1. 用户注册账号时，需提供真实、有效的手机号等信息，保证信息真实有效、未冒用他人信息。严禁伪造信息、批量注册、恶意注册小号。
              </p>
              <p class="yhys-page__paragraph">
                2. 账号归本站所有，用户仅拥有个人使用权，禁止转让、售卖、租借、共享账号给他人使用，禁止批量登录、脚本挂机、多设备异常登录。
              </p>
              <p class="yhys-page__paragraph">
                3. 用户自行保管账号密码、登录设备，因个人保管不当、主动转借账号导致的账号被盗、权益丢失、信息泄露、财产损失，由用户自行承担责任。
              </p>
              <p class="yhys-page__paragraph">
                4. 本站有权对长期未登录、异常操作、违规账号进行风控提醒、限制登录、冻结、注销处理，保障平台整体安全。
              </p>

              <h3 class="yhys-page__heading">三、音乐服务与会员权益规则</h3>
              <p class="yhys-page__paragraph">
                1. 本站所有音乐作品均为yours，包含原创词曲、原创编曲、原创录制内容，所有作品均已获得创作者合法授权，仅对本站用户开放试听、会员下载服务。
              </p>
              <p class="yhys-page__paragraph">
                2. 普通用户权益：可免费浏览平台内容、免费试听公开yours，无批量下载、高清音源、会员专属曲目权限。
              </p>
              <p class="yhys-page__paragraph">
                3. 付费会员权益：开通会员后，可享受平台标注的会员专属原创歌曲试听、高清音源下载、专属音质、无广告试听等对应权益，具体权益以页面实时展示为准。
              </p>
              <p class="yhys-page__paragraph">
                4. 会员付费规则：会员费用为平台增值服务使用费，一经付费开通，非平台故障、非合规问题，不支持无理由退款、部分退款、延期补偿。因用户自身原因未使用、忘记使用、账号共享违规导致权益冻结的，不予退款补偿。
              </p>
              <p class="yhys-page__paragraph">
                5. 会员下载的yours，仅可用于个人非商业欣赏使用。严禁将下载音源用于二次剪辑、翻唱商用、直播商用、网盘倒卖、售卖音源、二次传播分发等一切商业及侵权行为。一旦发现，平台有权立即封禁账号、收回所有会员权益，并保留追究法律责任的权利。
              </p>
              <p class="yhys-page__paragraph">
                6. 平台会持续更新原创曲库，新增原创曲目会同步纳入会员权益范围，部分老旧原创作品因创作者授权到期、版权调整，可能会下架或调整权限，用户对此表示理解，不以此要求退款、赔偿。
              </p>

              <h3 class="yhys-page__heading">四、用户行为规范</h3>
              <p class="yhys-page__paragraph">
                所有用户使用本站服务，必须遵守国家法律法规及平台规则，严禁发生以下行为：
              </p>
              <ul class="yhys-page__list">
                <li>利用脚本、爬虫、外挂、批量工具爬取、抓取、批量下载本站yours音源、曲库数据、用户数据；</li>
                <li>破解、反编译、绕过平台权限，盗取会员专属音源、私自传播平台yours；</li>
                <li>在评论区、留言区发布涉政、色情、暴力、低俗、辱骂、造谣、广告、引流、侵权等违规内容；</li>
                <li>恶意攻击网站、干扰平台正常运行、刷量刷评、恶意投诉抹黑平台；</li>
                <li>以任何形式将平台yours用于商业盈利、二次分发、侵权传播；</li>
                <li>其他违反法律法规、公序良俗、损害平台及第三方合法权益的行为。</li>
              </ul>
              <p class="yhys-page__paragraph">
                用户出现上述违规行为，平台有权视情节轻重，采取删除内容、限制试听下载、冻结账号、永久封禁、清空会员权益等处置措施，造成平台损失的，需承担对应赔偿责任。
              </p>

              <h3 class="yhys-page__heading">五、平台服务说明与免责条款</h3>
              <p class="yhys-page__paragraph">
                1. 平台会尽力保障网站7×24小时稳定运行，保障用户正常试听、下载、使用会员权益，但因服务器维护、系统升级、网络波动、机房故障、黑客攻击、运营商故障、自然灾害等不可抗力因素导致的短暂无法访问、卡顿、功能异常，平台不承担赔偿责任。
              </p>
              <p class="yhys-page__paragraph">
                2. 平台所有yours内容均由创作者合法授权，若用户发现内容存在侵权问题，可随时联系平台反馈，平台将第一时间核查、下架处理。
              </p>
              <p class="yhys-page__paragraph">
                3. 用户因自身设备故障、网络问题、操作失误导致的下载失败、文件丢失、账号问题，平台不承担补偿及退款责任。
              </p>
              <p class="yhys-page__paragraph">
                4. 平台仅提供yours试听、下载服务，不承担用户个人使用行为产生的任何侵权、违规、法律责任。
              </p>

              <h3 class="yhys-page__heading">六、协议变更与终止</h3>
              <p class="yhys-page__paragraph">
                平台有权根据业务升级、合规要求、行业规则，适时修订本用户协议。协议修订后将在网站公示，公示后继续使用平台服务即视为认可新版协议。
              </p>
              <p class="yhys-page__paragraph">
                用户可随时停止使用平台服务、注销账号；用户违规的，平台可单方终止服务、封禁账号。
              </p>
            </div>
          </div>
        </div>

        <div v-if="activeTab === 'privacy'" class="yhys-page__section">
          <div class="yhys-page__article">
            <h2 class="yhys-page__article-title">隐私政策</h2>
            
            <div class="yhys-page__content-body">
              <h3 class="yhys-page__heading">一、政策说明</h3>
              <p class="yhys-page__paragraph">
                本隐私政策旨在如实告知您：本站会收集哪些信息、如何使用信息、如何保护您的个人隐私、绝不滥用用户数据。本政策适用于本站所有用户，对应《中华人民共和国网络安全法》和《中华人民共和国个人信息保护法》等合规要求，真实透明、无隐形条款。
              </p>
              <p class="yhys-page__paragraph">
                您使用本站注册、登录、试听、下载、开通会员、留言反馈等服务，即代表您同意本隐私政策的信息收集与使用规则。
              </p>

              <h3 class="yhys-page__heading">二、我们收集的用户信息</h3>
              <p class="yhys-page__paragraph">
                为保障账号安全、提供音乐服务、开通会员权益，我们仅收集服务必需信息：
              </p>
              <ul class="yhys-page__list">
                <li><strong>注册账号信息：</strong>用户注册、登录所需的手机号、账号昵称，用于账号核验、登录认证、找回密码。</li>
                <li><strong>会员付费信息：</strong>会员充值记录、订单信息、付费状态，用于确认会员权益、核对订单、处理售后问题（不收集银行卡、支付密码等敏感支付信息，支付全程由正规支付渠道完成）。</li>
                <li><strong>设备与访问日志信息：</strong>您访问网站时的设备型号、浏览器类型、IP地址、访问时间、试听记录、下载记录、页面浏览记录，用于平台运维、故障排查、风控防刷、优化yours推荐体验。</li>
                <li><strong>用户主动提交信息：</strong>您通过留言、反馈、客服咨询主动提交的文字、联系方式等信息。</li>
              </ul>

              <h3 class="yhys-page__heading">三、信息使用范围</h3>
              <p class="yhys-page__paragraph">
                我们收集的所有用户信息，仅用于以下合法用途，绝不私自倒卖、售卖、扩散用户个人信息：
              </p>
              <ul class="yhys-page__list">
                <li>为您提供yours试听、下载、会员权益等基础及增值服务；</li>
                <li>保障账号安全，识别异常登录、恶意爬虫、违规操作，防范风险；</li>
                <li>统计平台曲库使用数据，优化yours推荐、优化网站体验；</li>
                <li>处理用户咨询、售后、投诉、反馈问题；</li>
                <li>遵守国家法律法规、监管核查要求，配合合规备案、检查。</li>
              </ul>

              <h3 class="yhys-page__heading">四、信息共享与披露规则</h3>
              <p class="yhys-page__paragraph">
                1. 无用户授权，绝不对外共享：未经您本人明确同意，我们不会向任何第三方公司、机构、个人泄露、出售、出租您的个人信息。
              </p>
              <p class="yhys-page__paragraph">
                2. 仅以下合规场景可依法披露：法律法规要求、公安、司法、监管部门依法查询、调查取证的；为保障用户、平台、公众合法权益，在必要范围内依法提供的。
              </p>
              <p class="yhys-page__paragraph">
                3. 平台合作服务商（支付、运维服务商）仅可在服务必需范围内获取脱敏数据，且全部签署保密协议，严格约束数据使用。
              </p>

              <h3 class="yhys-page__heading">五、用户信息保护措施</h3>
              <p class="yhys-page__paragraph">
                1. 平台采用加密传输、加密存储、权限隔离机制，保护用户个人数据、订单数据、使用记录安全；
              </p>
              <p class="yhys-page__paragraph">
                2. 内部严格管控数据访问权限，仅限运维、合规岗位必要核查使用，严禁员工私自查阅、导出、泄露用户数据；
              </p>
              <p class="yhys-page__paragraph">
                3. 定期开展安全巡检、漏洞排查，防范数据泄漏、丢失、篡改风险；
              </p>
              <p class="yhys-page__paragraph">
                4. 一旦发生数据安全风险，平台将第一时间止损、排查、告知用户，并按法规要求上报处置。
              </p>

              <h3 class="yhys-page__heading">六、用户个人权利</h3>
              <p class="yhys-page__paragraph">
                1. 查询权：您可咨询客服查询自身账号信息、使用记录、会员订单信息；
              </p>
              <p class="yhys-page__paragraph">
                2. 更正权：个人信息有误的，可联系平台申请更正、修改；
              </p>
              <p class="yhys-page__paragraph">
                3. 删除与注销权：您可申请注销账号，账号注销后，平台将依规清理您的个人数据（留存合规备案记录除外）；
              </p>
              <p class="yhys-page__paragraph">
                4. 撤回授权：您可撤回非必要信息授权，撤回后可能导致部分服务无法正常使用。
              </p>

              <h3 class="yhys-page__heading">七、未成年人保护</h3>
              <p class="yhys-page__paragraph">
                本站面向全年龄段用户开放，未成年人使用本站服务前，需在监护人陪同、同意、指导下使用。平台不会主动收集未成年人敏感信息，若发现未成年人违规付费、违规使用，监护人可联系平台协助处理。
              </p>

              <h3 class="yhys-page__heading">八、Cookie与本地存储说明</h3>
              <p class="yhys-page__paragraph">
                本站会使用Cookie及本地存储技术，用于记住您的登录状态、偏好设置、会员状态，提升访问体验，不会通过Cookie窃取个人隐私信息。您可通过浏览器设置自主关闭Cookie功能，但可能影响网站正常使用。
              </p>

              <h3 class="yhys-page__heading">九、政策更新与联系我们</h3>
              <p class="yhys-page__paragraph">
                平台会根据法律法规更新、业务调整，适时修订本隐私政策，修订后将在网站公示，公示后生效。
              </p>
              <p class="yhys-page__paragraph">
                若您对本协议、隐私政策、个人信息保护有疑问、投诉、建议，可通过网站客服渠道联系我们，我们将及时核实、回复、处理。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Yhys',
  data() {
    return {
      activeTab: 'agreement',
      tabs: [
        { id: 'agreement', name: '用户协议' },
        { id: 'privacy', name: '隐私政策' }
      ]
    }
  },
  created() {
    const tab = this.$route.query.tab
    if (tab && (tab === 'agreement' || tab === 'privacy')) {
      this.activeTab = tab
    }
  }
}
</script>

<style scoped lang="scss">
.yhys-page {
  width: 100%;
  min-height: calc(100vh - 80px);
  font-family: Arial, Helvetica, sans-serif;
  position: relative;
  background-image: url('../../assets/gryh.jpg');
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;

  &__container {
    position: relative;
    z-index: 1;
    max-width: 800px;
    margin: 0 auto;
    padding: 40px 20px;
    box-sizing: border-box;
  }

  &__title {
    text-align: center;
    color: #ffffff;
    font-size: 28px;
    font-weight: 700;
    margin: 0 0 30px 0;
    letter-spacing: 1px;
  }

  &__tabs {
    display: flex;
    justify-content: center;
    background-color: #6b2a2a;
    border-radius: 4px 4px 0 0;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  &__tab {
    padding: 15px 30px;
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
    border-bottom: 3px solid transparent;

    &:hover {
      color: rgba(255, 255, 255, 0.9);
    }

    &--active {
      color: #ffffff;
      border-bottom-color: #f37021;
    }
  }

  &__content {
    background-color: #6b2a2a;
    border-radius: 0 0 4px 4px;
    padding: 30px;
  }

  &__section {
    color: #ffffff;
  }

  &__article {
    background-color: #5c2525;
    border-radius: 8px;
    padding: 25px;
  }

  &__article-title {
    font-size: 20px;
    font-weight: 700;
    color: #ffffff;
    margin: 0 0 8px 0;
    text-align: center;
  }

  &__article-date {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.5);
    text-align: center;
    margin: 0 0 25px 0;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__content-body {
    max-height: 500px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.3) transparent;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(255, 255, 255, 0.3);
      border-radius: 3px;
    }
  }

  &__heading {
    font-size: 16px;
    font-weight: 600;
    color: #f37021;
    margin: 20px 0 12px 0;
    padding-top: 15px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);

    &:first-child {
      margin-top: 0;
      padding-top: 0;
      border-top: none;
    }
  }

  &__paragraph {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.8;
    margin: 0 0 12px 0;
    text-align: justify;
  }

  &__list {
    margin: 0 0 12px 0;
    padding-left: 20px;
    list-style: disc;

    li {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      line-height: 1.8;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }

      strong {
        color: #f37021;
      }
    }
  }

  &__footer {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__footer-info {
    text-align: center;

    p {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.5);
      margin: 5px 0;
    }
  }
}

@media (max-width: 768px) {
  .yhys-page {
    &__container {
      padding: 20px 15px;
    }

    &__title {
      font-size: 22px;
    }

    &__tab {
      padding: 12px 20px;
      font-size: 13px;
    }

    &__content {
      padding: 20px;
    }

    &__article {
      padding: 20px;
    }

    &__content-body {
      max-height: 400px;
    }

    &__heading {
      font-size: 15px;
    }

    &__paragraph,
    &__list li {
      font-size: 13px;
    }
  }
}
</style>